import { Game, Admin, Public, PreLogin, PostLogin } from "../render";

const renders = {
  Game,
  Admin,
  Public,
  PreLogin,
  PostLogin,
};

export const useRender = (render: string) => {
  return renders[render];
};
